module.exports = __webpack_public_path__ + "media/images/arrow-lookin-darker-f71fca36b1a388c1b5b8e7fd2d11ff34.svg";